module.exports = __webpack_public_path__ + "static/media/write.31d4ef29.svg";